import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Panel } from 'primeng/panel';
import { HisCoreSharedModule } from '../../../../core/his-core-shared.module';
import { StoredReport } from '../../../model/stored-report';
import { Result } from '../bi-analysis-table/flat-table/model/result';


@Component( {
    selector: 'his-bi-analysis-information',
    imports: [Panel, HisCoreSharedModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './bi-analysis-information.component.html',
} )
export class BiAnalysisInformationComponent {

    @Input( { required: true } ) report!: StoredReport;
    @Input( { required: true } ) result!: Result;

}
